import React from 'react'

import { Label } from 'semantic-ui-react';

import { EnumSensorStatus } from 'enums';

import './style.css';

class SensorStatus extends React.Component {
  render() {

    const { status } = this.props;

    return (
      <Label className="sensor-status" horizontal size="tiny" color={EnumSensorStatus.color(status)}>
        {EnumSensorStatus.name(status)}
      </Label>
    );
  }
}

export default SensorStatus;
